var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-pm-alarm-tree"},[_c('ejs-treeview',{ref:"pmAlarmQueryTree",attrs:{"fields":_vm.fieldsOfPmAlarmQueryTree,"nodeSelected":_vm.nodeSelectedOfPmAlarmQueryTree}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }